/** @jsx h */
import { h } from 'preact'

const DocumentIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='56'
    height='56'
    viewBox='0 0 56 56'
  >
    <g fill='none' fillRule='evenodd'>
      <circle cx='28' cy='28' r='28' fill='#FFF' />
      <path
        fill='#2F3A4A'
        fillOpacity='0.5'
        d='M19 9h22a2 2 0 0 1 2 2v30a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2z'
      />
      <g transform='translate(13 13)'>
        <path
          fill='#FFF'
          stroke='#2F3A4A'
          strokeWidth='1.5'
          d='M2 0h15.172a2 2 0 0 1 1.414.586l6.828 6.828A2 2 0 0 1 26 8.828V32a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z'
        />
        <rect width='14' height='2' x='2' y='28' fill='#2F3A4A' rx='1' />
        <rect width='22' height='2' x='2' y='24' fill='#2F3A4A' rx='1' />
        <rect width='22' height='2' x='2' y='20' fill='#2F3A4A' rx='1' />
        <rect width='22' height='2' x='2' y='16' fill='#2F3A4A' rx='1' />
        <path fill='#2F3A4A' d='M18 0v7a1 1 0 0 0 1 1h7l-8-8z' />
      </g>
    </g>
  </svg>
)

export default DocumentIcon
